import React from 'react';

// Ícones de traço do protótipo. O `Icon` do Design System é de preenchimento e não tem as
// variantes de que a tela precisa (estrela vazada/cheia, pasta aberta, chevron fino).
const PATHS = {
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />,
  folderOpen: (
    <>
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v1H7l-4 9z" />
      <path d="M7 10h15l-4 9H3z" />
    </>
  ),
  chevronRight: <path d="M9 6l6 6-6 6" />,
  chevronLeft: <path d="M15 6l-6 6 6 6" />,
  plus: <path d="M12 5v14M5 12h14" />,
  upload: <path d="M12 20V9M7 14l5-5 5 5M5 4h14" />,
  download: <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4-4" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  refresh: <path d="M20 11a8 8 0 1 0-2.3 5.7M20 4v7h-7" />,
  star: <polygon points="12 3 14.8 9 21 9.6 16.3 13.8 17.7 20 12 16.7 6.3 20 7.7 13.8 3 9.6 9.2 9" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
};

export type ExplorerIconName = keyof typeof PATHS;

export default function ExplorerIcon({
  name,
  size = 16,
  strokeWidth = 2,
  filled = false,
  className = '',
}: {
  name: ExplorerIconName;
  size?: number;
  strokeWidth?: number;
  /** Preenche com a cor atual (estrela fixada, pasta da árvore). */
  filled?: boolean;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`file-explorer-icon ${className}`.trim()}
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
